module.exports = {
  LOGGER: 'LOGGER',
  ORDER: 'ORDER',
  PAYMENT_PAGE: 'PAYMENT_PAGE',
  STATIC: 'STATIC',
  HEALTH_CHECK: 'HEALTH_CHECK',
  SUBSCRIPTION_PORTAL: 'SUBSCRIPTION_PORTAL',
  API: 'API',
};